export default __webpack_public_path__ + "dfaf1b82e95448106f587737a3466ba8.png";